// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3hbqH","error":"Textarea_error__1K9s-","readonly":"Textarea_readonly__4xNGy","disabled":"Textarea_disabled__3qIfa"};